import { Component, EventEmitter, Input, Output, OnChanges} from '@angular/core';
import { JoiFile } from 'globals/store/files.model';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export type FileType = 'Presentation' | 'Stand' | 'File' | 'Asset' | 'Public' | 'CTA' | 'Footer Links'

@Component({
    selector: 'file-link',
    template: `
<div class="file-info-holder" [ngClass]="{presentation:type == 'Presentation' || type == 'Stand'}">
  <icon class="presentation" *ngIf="type == 'Presentation'" [icon]="'presentation18'"></icon>
  <icon class="presentation" *ngIf="type == 'Stand'" [icon]="'EXHIBITORS_18'"></icon>
  <div>
    <div class="file-info-main" [ngClass]="{ warn: !urlOk && file.linkUrl }">
      <button *ngIf="!!ctaLink" matButton="filled" color="primary" class="cta ellipsis" (click)="helpers.goToUrl($event, file.linkUrl)">{{ file.filename }}</button>
      <div *ngIf="!ctaLink" (click)="!urlOk ? null : helpers.openInNewTab(file.linkUrl || ''); $event.stopPropagation()" [ngClass]="{ fileHover: !!file.linkUrl && urlOk }">
        <div class="file-name-url">{{ onlyOpenInNew ? '' : (file.filename || file.linkUrl) }} <mat-icon *ngIf="!!file.linkUrl">open_in_new</mat-icon></div>
      </div>
      

      <ng-container *ngIf="!readOnly && !onlyLink">
        <span class="dot">•</span><span class="link" (click)="editFile($event)">Edit</span>
      </ng-container>
    </div>
    <div class="file-info-time" *ngIf="!onlyLink && !hideByline">{{ file.modified ? 'Modified' : 'Added' }} by {{file.by}}<span *ngIf="file.created">, {{ (file.modified ? file.modified : file.created ) | date: 'HH:mm on d MMMM y' }}</span></div>
  </div>
</div>
`,
    styleUrls: ['./file-link.scss'],
    standalone: true,
    imports: [IconComponent, MatButtonModule, CommonModule, MatIconModule]
})
export class FileLinkComponent implements OnChanges {

    @Input() file: JoiFile;
    @Input() ctaLink = false
    @Output() openFile: EventEmitter<any> = new EventEmitter();
    @Input() type: FileType = 'File'
    @Input() readOnly = true;
    @Input() onlyLink = false
    @Input() onlyOpenInNew = false
    @Input() hideByline = false

    helpers = publicHelpers
    urlOk: boolean

    editFile(event) {
      event.stopPropagation()
      this.openFile.emit(event)
    }

    ngOnChanges(changes) {
      if (changes.file.currentValue) {
        this.urlOk = this.helpers.urlOk(changes.file.currentValue.linkUrl)
      // } else {
        // console.log({ changes })
      }
    }
}
